import { render } from "./AppMain.vue?vue&type=template&id=078753dd"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/components/AppMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "078753dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('078753dd', __exports__)) {
    api.reload('078753dd', __exports__)
  }
  
  module.hot.accept("./AppMain.vue?vue&type=template&id=078753dd", () => {
    api.rerender('078753dd', render)
  })

}


export default __exports__